export default __webpack_public_path__ + "static/media/wizard.54a41689.png";